import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { NgIconsModule } from '@ng-icons/core';
import { AfraImageComponent } from '../afra-image/afra-image.component';

@Component({
  selector: 'app-teacher-info-card',
  standalone: true,
  imports: [CommonModule, RouterModule, NgIconsModule, AfraImageComponent],
  templateUrl: './teacher-info-card.component.html',
  styleUrl: './teacher-info-card.component.css',
})
export class TeacherInfoCardComponent {
  @Input() teacherId!: number;
  @Input() name!: string;
  @Input() avatar?: string;
  @Input() position?: string;
  @Input() workshopsCount?: number;
  @Input() bio?: string;
  @Input() linkName = false;
}
